import { useContext, useRef, useState } from 'react';
import { Collapse, Form, Select, Divider, Menu, Switch } from 'antd';
import Icon from '@ant-design/icons';
import { useIntl } from 'react-intl';

import { HubsContext } from 'contexts/hub.context';
import { NUMBER_TEXT } from 'constants/form';

import BRButton from 'components/BRButton/BRButton';
import LatLngForm from 'components/Geofences/components/LatLngForm/LatLngForm';
import BRFormInputs from 'components/BRFormInputs/BRFormInputs';

import { ReactComponent as ChevronDown } from 'assets/bosta-icons/Chevron-down.svg';

import './GeofencesActions.less';

const GeofencesActions = ({
  handleHubChange,
  selectedHub,
  handleSimplifyPolygon,
  handlePlotGeolocation,
  editingHubId,
  handleSaveClick,
  selectedHubs,
  handleShowStreetCodes,
  showStreetCodes
}) => {
  const [isHubsDropdownOpen, setIsHubsDropdownOpen] = useState(false);
  const simplifyFormRef = useRef(null);

  const { allHubs } = useContext(HubsContext);

  const intl = useIntl();

  return (
    <Collapse
      className="br-geofences-actions__collapse"
      ghost
      defaultActiveKey={['0']}
      expandIcon={({ isActive }) => (
        <Icon
          component={ChevronDown}
          rotate={isActive ? 0 : -90}
          className="ant-icon-md"
        />
      )}
    >
      <Collapse.Panel
        header={intl.formatMessage({
          id: 'hubs_geofencing.control_panel.title'
        })}
      >
        <Form.Item
          label={intl.formatMessage({
            id: 'sidebar.hub'
          })}
        >
          <Select
            mode="multiple"
            value={selectedHub?.hubId}
            placeholder={intl.formatMessage({
              id: 'hubs.rto_modal.select_hub_modal.dropdown_placeholder'
            })}
            showSearch
            showArrow
            optionFilterProp="name"
            onChange={handleHubChange}
            options={allHubs}
            fieldNames={{
              label: 'name',
              value: '_id'
            }}
            maxTagCount={1}
            // dropdownRender={renderHubsDropdown}
            open={isHubsDropdownOpen}
            onDropdownVisibleChange={setIsHubsDropdownOpen}
          />
        </Form.Item>
        <div className="br-geofences-actions__switch">
          <Switch
            onChange={handleShowStreetCodes}
            disabled={selectedHubs.length !== 1}
            checked={showStreetCodes}
          />
          <div className="label_sm">
            {intl.formatMessage({
              id: 'hubs_geofencing.control_panel.show_street_codes'
            })}
          </div>
        </div>
        <Divider />
        <LatLngForm handlePlotGeolocation={handlePlotGeolocation} />
        <Divider />
        <Form
          ref={simplifyFormRef}
          initialValues={{
            tolerance: 0.0001
          }}
          onFinish={handleSimplifyPolygon}
        >
          <div className="br-geofences__simplify-action">
            <BRFormInputs
              formRef={simplifyFormRef}
              type={NUMBER_TEXT}
              name="tolerance"
              acceptFractions
              label={intl.formatMessage({
                id: 'hubs_geofencing.control_panel.tolerance'
              })}
              rules={[{ required: true }]}
            />
            <BRButton
              label={intl.formatMessage({
                id: 'hubs_geofencing.control_panel.simplify'
              })}
              disabled={!editingHubId}
              htmlType="submit"
            />
          </div>
        </Form>
        <BRButton
          className="br-geofences-actions__save-changes"
          type="primary"
          label={intl.formatMessage({
            id: 'hubs_geofencing.control_panel.save_changes'
          })}
          block
          disabled={
            !editingHubId ||
            (selectedHubs.length === 1 &&
              !selectedHubs[0]?.formattedPolygon?.length)
          }
          onClick={handleSaveClick}
        />
      </Collapse.Panel>
    </Collapse>
  );
};

export default GeofencesActions;
